import React from 'react';
import { useHistory } from 'react-router-dom';

export const TabButtons = ({ tabParams, resetParams}) => {
  const history = useHistory();
  const info = history?.location?.state;
  const handleChangeView = (type) => {
    const params = {
      ...info,
    };
    delete params.searchKey;
    delete params.searchValue;
    delete params.sortType;
    delete params.orderType;

    history.push({
      state: resetParams ? {
        skip: 0,
        page: 1,
        viewType: type,
      } :{
        ...params,
        skip: 0,
        page: 1,
        viewType: type,
      },
    });
  };

  return(
      <div className="tab-buttons-wrapper">
        {tabParams?.map((i,j) => (
          <button
            key={j}
            onClick={() => handleChangeView(i?.type)}
            className={ (info?.viewType === i?.type || !info?.viewType && j === 0) ? 'active-btn' : 'passive-btn'}
          >
            {i?.name}
          </button>
        ))}
      </div>
  )
}